import React, { Component } from "react";
import { ButtonToolbar, Button, Modal, Tabs, Tab } from "react-bootstrap";
import Activities from "./activities";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../actions/index";
import { constants, KeolisSpinner, moment } from './common/commonExport';
import PDFPrinting from '../containers/PDFPrinting';
import ToggleButton from 'react-toggle-button';
import ScrollArea from "react-scrollbar";
import EandDActivies from './e-and-d-activities';



class HoursOfServiceModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleState: false,
      key: 1
    }
  }

  onAcceptClaim() { // Admin Accepts Claim
    this.props.onShowModal(constants.hosModals.Comments_Modal);
  }

  onRejectClaim() { // Admin Rejects Claim
    this.props.onShowModal(constants.hosModals.Comments_Modal, constants.REJECT);
  }

  onRecertify(workdayId) { // emp wants to recertify
    this.props.onRecertify(workdayId);
  }
  renderAdminClaimButton() {
    var workday = this.props.workday, allowRecertify = this.props.workday.allowRecertify,
      role = this.props.role.role;
    if (
      role == constants.roles.ADMIN_ROLE &&
      workday.wdy_claim_status == constants.PENDING_CLAIM
    ) {

      return (
        <div>
          <button
            className="btn btn-danger btnWidth btnDangerColor displayRight"
            onClick={() => this.onRejectClaim()}>
            Reject{" "}
          </button>
          <button
            className="btn btn-primary btnPrimaryColor btnWidth"
            onClick={() => this.onAcceptClaim()}>
            Accept{" "}
          </button>
        </div>
      );
    } else if (allowRecertify === 'true' && role != constants.roles.ADMIN_ROLE && this.props.workday.wdy_certify_status == constants.CERTIFIED) {
      let workdayId = this.props.workday.Id;
      return (
        <div className="uncertify">
          <button
            className="btn btn-danger btnWidth btnDangerColor displayRight"
            onClick={() => this.onRecertify(workdayId)}>Un-Certify</button>
        </div>)
    }
  }

  renderActivities() { // load Activities
    var workday = this.props.workday;
    if (workday && Object.keys(workday).length > 0) {
      return <Activities workdays={workday} eventKey={this.state.key} isHOSModal={true} oncloseErrPop={() => this.oncloseErrPop.bind(this)} />;
    } else {
      return (
        <KeolisSpinner />
      );
    }
  }

  // render certified on text
  renderCertifiedStatus() {
    let workday = this.props.workday, certifyStatus = this.props.workday.wdy_certify_status;
    if (this.props.authDetails.role == constants.roles.EMPLOYEE_ROLE && certifyStatus == constants.CERTIFIED) {
      return (
        <p className="certifiedTxt">Certified on {workday.wdy_certify_date}</p>
      )
    } else {
      return ""
    }

  }

  // render comments on right side
  renderComments(comments) {
    if (comments) {
      comments = comments.split("~");
      if (comments.length > 1) {
        return comments.map(function (comment, index) {
          if (comments.length == index + 1) {
            return ('');
          } else {
            if (comment.split('^-').length > 1) {
              if (comment.split('^-')[1] != undefined && !comment.split('^-')[1].includes("undefined") && comment.split('^-')[1] != "") {
                return (
                  <span className="comment" key={index}>
                    <span className="commentBy">{comment.split('^-')[0] + " - "}</span>
                    <span>{comment.split('^-')[1]}</span>
                  </span>
                );
              } else {
                return ("");
              }
            } else {
              return (
                <span className="comment" key={index}>
                  <span className="commentBy">{comment.split('-')[0] + " - "}</span>
                  <span>{comment.split('-')[1]}</span>
                </span>
              );
            }
          }
        })
      } else {
        return comments;
      }
    }
  }
  oncloseErrPop() {
    this.onHideModal();
  }
  // toggle activities
  toggleButton() {
    let toggleState = this.state.toggleState;
    this.setState({ toggleState: !toggleState }, () => this.props.toggleWorkday(this.state.toggleState));
  }

  // hiding component
  onHideModal() {
    this.setState({ key: 1 })
    this.props.hideModal(false, constants.hosModals.Certified_Modal)
    this.props.toggleWorkday(false);
  }

  handleTabChange(key) {
    this.setState({ key: key })
  }

  renderEnDTab() {
   if (this.state.key == 3) {
      return (
        <EandDActivies />
      )
    }
  }
  renderLogsTab(){
    return (
      <Tabs id="tabs" activeKey={this.state.key}>
        <Tab eventKey={this.state.key} title="Details">
          {this.renderActivities()}
        </Tab>
      </Tabs>
    );
  }
  render() {

    if (this.props.showModal) {
      var modalStatus = this.props.showModal,
        workday = this.props.workday,
        modalName = this.props.modalName,
        role = this.props.role.role;
      var workday = this.props.workday, firstName = '', lastName = '', data = [];
      const isMenumappingConf = this.props.authDetails.role == constants.roles.ADMIN_ROLE || 
                (this.props.authDetails.activeMenus && Array.isArray(this.props.authDetails.activeMenus) && this.props.authDetails.activeMenus.length > 0) ;
      if (workday && Object.keys(workday).length > 0) {
        var empFullName = workday.emp_full_name,
          firstName = empFullName.split(" ")[1],
          lastName = empFullName.split(" ")[0];
        data = workday.duty_activity;
      }
      return (
        <Modal className={"hoursServiceModal"}
        animation ={false}
          show={modalStatus && modalName == constants.hosModals.Certified_Modal}
          onHide={this.onHideModal.bind(this)}
          bsSize="large"
          aria-labelledby="contained-modal-title-lg">
          <Modal.Header closeButton>
            {this.props.role.role == constants.roles.ADMIN_ROLE &&
              workday.wdy_certify_status == constants.CLAIM ? (
                <div className="hos-modal-header">
                  <div style={{ width: '100%' }}>
                    <span>Claim for {firstName} {lastName}</span>
                    <br />
                    <span>Service Date: {workday.wdy_date} </span>
                    <br />
                    <span>Division: {workday.division} </span>
                  </div>
                </div>
              ) : (
                <div className="hos-modal-header">
                  <div className="equalColumn hideVisibility">-</div>
                  <div className="equalColumn">
                    <span>{firstName} {lastName}</span>
                    <br />
                    <span> {isMenumappingConf ? 'Pay Details' : 'HOS Details'} </span>
                    <br />
                    <span> Service Date {workday.wdy_date} </span>
                  </div>
                  <div className="equalColumn">
                    <PDFPrinting hidden={this.props.role.role == constants.roles.ADMIN_ROLE ? true : false} Page="Projects" data={data}
                      compTitle={isMenumappingConf ? "Pay Details" : "Hours of service"} />
                  </div>
                </div>
              )}
          </Modal.Header>
          <Modal.Body>
            <div className="adminModal">
              <div className="row">
                <div className="col-sm-6 col-md-6 activitiesMdlLeft">
                  <div className="activitiesContainer">
                    <div className="activity-header">{isMenumappingConf ? "Pay Details" : "Hours of Service"}</div>
                    <div className="activitiesBody">
                      {role == constants.roles.ADMIN_ROLE ? this.renderActivities() :                      
                      <Tabs id="tabs" activeKey={this.state.key}
                        onSelect={(e) => this.handleTabChange(e)}>
                        <Tab eventKey={1} title="Summary">
                          {this.renderActivities()}
                        </Tab>
                        <Tab eventKey={2} title="Details">
                          {this.renderActivities()}
                        </Tab>
                        <Tab eventKey={3} title="E&D">
                          {this.renderEnDTab()}
                        </Tab>
                      </Tabs>}
                    </div>
                  </div>
                </div>
                {role == constants.roles.ADMIN_ROLE &&
                  workday.wdy_certify_status == constants.CLAIM ? (
                    <div className="col-sm-6 col-md-6 activitiesMdlRight">
                      <div className="activitiesContainer">
                        <div className="activity-header">
                          {isMenumappingConf ? "Adjusted Pay Details" : "Adjusted Hours of Service"}
                        </div>
                        <div className="activitiesBody">
                          <Activities workdays={workday} adjustedHOS={true} oncloseErrPop={() => this.oncloseErrPop.bind(this)}/>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-sm-6 col-md-6 activitiesMdlRight">
                      <div className="activitiesContainer">
                        <div className="activity-header">{isMenumappingConf ? "Comments" : "Logs"}</div>
                        <div className="activitiesBody">
                          {workday.wdy_comments == "NULL" ? (
                            <span>"No comments"</span>
                          ) :
                            this.renderComments(workday.wdy_comments)
                          }
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {this.renderCertifiedStatus()}
            {this.renderAdminClaimButton()}</Modal.Footer>
        </Modal>
      );
    } else {
      return <div />;
    }
  }
}

function mapStateToProps(state) {
  return {
    workday: state.workday.workday,
    workdayLoading: state.workday.isLoading,
    workdays: state.workdays.workdays,
    showModal: state.modals.showModal,
    modalName: state.modals.modalName,
    role: state.role,
    authDetails: state.authState
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      hideModal: actions.hideModalAction,
      onShowModal: actions.showModalAction,
      onRejectClaim: actions.onRejectClaimAction,
      onRecertify: actions.onRecertifyAction,
      toggleWorkday: actions.toggleWorkdayAction
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(
  HoursOfServiceModal
);
